export const formatIndoPhoneNumber = (phone) => {
  let cleaned = ("" + phone).replace(/\D/g, "");

  // If it starts with 0, replace with 62
  if (cleaned.startsWith("0")) {
    cleaned = "62" + cleaned.substring(1);
  }

  // Flexible match: 62 + first 3 + next 4 + the rest
  const match = cleaned.match(/^(62)(\d{3})(\d{4})(\d{1,5})$/);

  if (match) {
    return `+${match[1]} ${match[2]}-${match[3]}-${match[4]}`;
  }

  return phone;
};
